<template>
  <div
    :class="{
      'state-switch': true,
      error,
    }"
    :data-state-active="stateActive"
    :style="{
      '--num-states': states.length,
      '--percentage-offset': states.length === 2 ? '45%' : '0%',
    }"
  >
    <div class="label" @click="toggle(firstState.value)">
      {{ firstState.label }}
    </div>
    <div class="bar">
      <div :title="firstState.label" @click="toggle(firstState.value)" />
      <div
        v-if="states.length === 3"
        :title="states[1].label"
        @click="inputValue = states[1].value"
      />
      <div :title="lastState.label" @click="toggle(lastState.value)" />
    </div>
    <div class="label" @click="toggle(lastState.value)">
      {{ lastState.label }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaseStateSwitch',
  model: {
    prop: 'value',
    event: 'update',
  },
  props: {
    value: {
      default: null,
    },
    states: {
      type: Array,
      default: () => [
        {
          value: true,
          label: 'Ja',
        },
        {
          value: null,
          label: 'Standard',
        },
        {
          value: false,
          label: 'Nein',
        },
      ],
      validator: (states) => Array.isArray(states) && [2, 3].includes(states.length),
    },
    error: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('update', value);
      },
    },
    stateActive() {
      const stateInx = this.states.findIndex(
        (state) => state.value === this.value,
      );
      if (stateInx === 0) {
        return 'first';
      }
      if ((stateInx === 1 && this.states.length === 2) || stateInx === 2) {
        return 'last';
      }
      return 'none';
    },
    firstState() {
      return this.states[0];
    },
    lastState() {
      return this.states.length === 3 ? this.states[2] : this.states[1];
    },
  },
  watch: {
    error() {
      this.$nextTick(() => {
        this.$refs.switch.style.marginBottom = `${this.$refs.error.scrollHeight}px`;
      });
    },
  },
  methods: {
    toggle(val) {
      if (
        val === this.inputValue
        && this.states.length === 3
      ) {
        this.inputValue = this.states[1].value;
      } else {
        this.inputValue = val;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$bar-width: 3.625em;
$bar-height: 1.3125em;
$indicator-size: 1.4375em;

.state-switch {
  position: relative;
  width: auto;
  margin: 0;
  display: flex;
  align-items: center;
  flex-basis: fit-content;
  flex-wrap: wrap;

  .label {
    font-weight: 400;
    position: relative;
    transition: 0.5s;
    cursor: pointer;
  }

  .bar {
    flex: 0 0 $bar-width;
    width: $bar-width;
    margin: 0 10px;
    display: flex;
    height: $bar-height;
    border-radius: 99px;
    background-color: #fff;
    position: relative;
    transition: background-color 0.625s ease-in-out;
    border: 1px solid var(--base-input--accent-color);

    div {
      flex: 0 0 calc(#{$bar-width} / var(--num-states));
      cursor: pointer;
    }

    &:after {
      position: absolute;
      content: "";
      display: block;
      top: calc(50% - 1px);
      left: calc(50% - (#{$indicator-size} / 2));
      transform: translateX(0) translateY(-50%);
      height: $indicator-size;
      width: $indicator-size;
      border-radius: 1em;
      background-color: #ffffff;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
      transition: transform 0.625s ease-in-out;
    }
  }

  &[data-state-active="first"] {
    .label:first-child {
      font-weight: 700;
    }
    .bar {
      background-color: var(--company-main-primary);
      &:after {
        transform: translateX(
            calc(
              (#{$bar-width} / var(--num-states) * -1) +
                var(--percentage-offset)
            )
          )
          translateY(-50%);
      }
    }
  }
  &[data-state-active="last"] {
    .label:last-child {
      font-weight: 700;
    }
    .bar {
      background-color: var(--company-main-secondary);
      &:after {
        transform: translateX(
            calc(#{$bar-width} / var(--num-states) - var(--percentage-offset))
          )
          translateY(-50%);
      }
    }
  }
}
</style>
